export const AGENDA = {
  START: "START",
  PAUSE: "PAUSE",
  RESUME: "RESUME",
  STOP: "STOP",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
};
